<template>
  <ul class="board_directors_list">
    <li class="director_item" v-for="(item,index) in list" :key="index">
      <div class="avatar_box">
        <!-- <img src="../assets/img/avatar.png" alt /> -->
      </div>
      <div class="item_info">
        <h2>{{item.name}}</h2>
        <h5>{{item.address}}</h5>
        <ul class="item_contact">
          <li class="contact_item">
            <router-link to="/">
              <i class="iconfont icon-mianshulogo"></i>
            </router-link>
          </li>
          <li class="contact_item">
            <router-link to="/">
              <i class="iconfont icon-twitter"></i>
            </router-link>
          </li>
          <li class="contact_item">
            <router-link to="/">
              <i class="iconfont icon-weibo"></i>
            </router-link>
          </li>
          <li class="contact_item">
            <router-link to="/">
              <i class="iconfont icon-weixin"></i>
            </router-link>
          </li>
        </ul>
      </div>
    </li>
  </ul>
</template>

<script>
export default {
  name: "homedirectoritem",
  props: {
    list: {
      type: Array,
      value: [],
    },
  },
};
</script>

<style lang="less" scoped>
.board_directors_list {
  display: flex;
  .director_item {
    flex: 1;
    height: 320px;
    position: relative;
    margin: 0 5px;
    .avatar_box {
      width: 144px;
      height: 144px;
      background: #969696;
      border-radius: 50%;
      margin: 0 auto;
      position: absolute;
      left: 50%;
      margin-left: -72px;
      top: 0;
      z-index: 2;
      img {
        width: 100%;
        height: 100%;
        border-radius: 50%;
      }
    }
    .item_info {
      position: absolute;
      left: 0;
      top: 72px;
      width: 100%;
      height: 255px;
      border: 1px solid #e8e8e8;
      border-radius: 8px;
      padding: 104px 0 38px;
      text-align: center;
      h2 {
        font-size: 18px;
        color: #262626;
        line-height: 34px;
      }
      h5 {
        font-size: 16px;
        line-height: 24px;
        color: #6a6a6a;
        margin-bottom: 27px;
      }
      .item_contact {
        display: flex;
        justify-content: center;
        
        .contact_item {
          padding: 0 6px;
          a {
            .iconfont {
              color: #1954c9;
              font-size: 20px;
            }
          }
        }
      }
    }
  }
}
</style>